import { ReactNode } from "react";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useStyles } from "./styles";

interface IInfoReadonlyFieldValueProps {
  title: string;
  value?: string;
  siblingEl?: ReactNode;
}

const InfoReadonlyFieldValue = ({
  title,
  value,
  siblingEl,
}: IInfoReadonlyFieldValueProps) => {
  const classes = useStyles();

  return (
    <div className={classes.readonlyField}>
      <Typography className={classes.bottomSpacedText} variant="body1">
        {title}
      </Typography>
      <Typography className={classes.bottomSpacedText} variant="body1">
        <strong>{value}</strong>
      </Typography>

      {siblingEl}
    </div>
  );
};

export default InfoReadonlyFieldValue;
